import { passCodes } from '../passCodes';
import track15 from '../../../../assets/audio/tracks/track15.mp3';

const hints = [
    {
        text: 'Kódem je: žlutá',
        solution: true,
    },
];
export const step15color = {
    id: 14,
    title: '7. stanoviště',
    taskText: `
        <p>
            Tady si napiš barvu toho velkýho kulatýho před náma, toho, co je na domě. 
        </p>
        <p>    
            Jinak pokud nevíš, tak tohle je mateřská škola. Té se raději vyhýbám, malé děti mě rády tahají za ocas.
        </p>
    `,
    cipher: {
        label: 'Úkol',
        text: 'Zadejte barvu.',
    },
    catImage: 6,
    audio: track15,
    snowAudio: track15,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[9],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
